import axios from "axios";
import { service_const } from "./consts";
import { openLogin, removeStorage } from "@/assets/js/utils";

axios.defaults.timeout = 240000;
axios.defaults.baseURL = service_const.basePath;

//http请求拦截器
axios.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// http响应拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.data.code == "5004") {
      alert(response.data.msg, () => {
        removeStorage(service_const.tokenKey);
        window.location.href = "/";
      });
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);



// WEBPACK FOOTER //
// ./src/assets/js/interceptors.js